//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Traceline.js";
import "../no/ugmath.js";
let d=[[[0,"EndDirection",1,"Direction",0],[0,"EndOffset",1,0],[0,"EndPoint",1,"Point",0],[0,"Mode",1,0],[0,"Orientation",1,0],[0,"Solution",1,0],[0,"StartDirection",1,"Direction",0],[0,"StartOffset",1,0],[0,"StartPoint",1,"Point",0]],[[["n_segment_constraints","segment_indices","segment_lengths"],"GetSegmentConstraints",{},0,0],[["segment_indices","segment_lengths"],"SetSegmentConstraints",{},2,0],[["segment_index"],"RemoveSegmentConstraint",{},1,0]],[]];
SPLM.AutomaticTraceline = class extends SPLM.Traceline{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AutomaticTraceline";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AutomaticTraceline.ModeOption = Object.freeze({
    "Evaluate" : "Evaluate", "Orientation" : "Orientation", "Infer" : "Infer"});

export default SPLM;